// Deliberately loose: the backend re-validates with Symfony's Email
// constraint, this only catches obvious typos client-side
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

export type ParsedEmails = {
  readonly valid: string[]
  readonly invalid: string[]
}

/**
 * Splits a free-text email list on commas and new lines, trims, dedupes
 * (case-insensitively) and partitions into valid and invalid entries
 */
export default (raw: string): ParsedEmails => {
  const seen = new Set<string>()
  const valid: string[] = []
  const invalid: string[] = []

  for (const entry of raw.split(/[\r\n,]+/)) {
    const email = entry.trim()
    const key = email.toLowerCase()

    if (!email || seen.has(key)) {
      continue
    }
    seen.add(key)
    if (EMAIL_PATTERN.test(email)) {
      valid.push(email)
    } else {
      invalid.push(email)
    }
  }

  return { valid, invalid }
}
